import { render, staticRenderFns } from "./SG.vue?vue&type=template&id=1ab4a7cc&scoped=true"
import script from "./SG.vue?vue&type=script&lang=js"
export * from "./SG.vue?vue&type=script&lang=js"
import style0 from "./SG.vue?vue&type=style&index=0&id=1ab4a7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab4a7cc",
  null
  
)

export default component.exports